import { Label } from '@cian/ui-kit/label';
import React, { memo } from 'react';

export const OwnerBadgeComponent: React.FC = () => {
  return (
    <Label background="surface-positive-default" color="accent-positive-primary" data-mark="OwnerBadge">
      Собственник
    </Label>
  );
};

OwnerBadgeComponent.displayName = 'OwnerBadge';

export const OwnerBadge = memo(OwnerBadgeComponent);
